import React from "react";
import noshow from "../Assets/no-show.gif";
import { Link } from "react-router-dom";
import { FirstPageSharp, LastPage } from "@mui/icons-material";
import { useEffect } from "react";

function NotFound() {
  useEffect(() => {
    document.getElementsByClassName("navbar")[0].style.display = "none";
    document.getElementsByClassName("footer")[0].style.display = "none";
  }, []);

  return (
    <div className="bg-gray-300 h-[100vh]">
      <div className="pt-10 items-center flex justify-between px-4 sm:px-10 md:px-16">
        <button className="bg-gradient-to-br from-gray-800 via-slate-500 to-slate-700 text-white p-2 rounded-3xl text-sm font-bold hover:transform translate duration-800 hover:scale-110">
          <FirstPageSharp />
          <Link to="/">HomePage</Link>
        </button>
        <button className="bg-gradient-to-br from-gray-800 via-slate-500 to-slate-700 text-white p-2 rounded-3xl text-sm font-bold hover:transform translate duration-800 hover:scale-110">
          <Link to="/login">LoginPage</Link>
          <LastPage />
        </button>
      </div>
      <div className="mt-10 bg-gradient-to-br from-gray-800 via-slate-500 to-slate-700 block m-auto lg:mx-40 border rounded-lg">
        <img src={noshow} className="w-full lg:h-[24rem]" alt="noshow" />
      </div>

      <div className="mt-6 text-center md:mt-10">
        <h1 className="text-3xl md:font-black md:text-5xl font-bold text-gray-800">
          Sorry page not found
        </h1>
      </div>
    </div>
  );
}

export default NotFound;
